module.exports = __webpack_public_path__ + "static/media/SelfieDoodle.52d22bc0.png";